import countries from "../data/countries.json";

export const getCountryFromCode = (code: string) => {
  return countries.find((country) => country.code === code)?.name;
};
